import { Component, OnInit } from "@angular/core";

import { SiAuthenticationService } from "@strategic-insights/ng-authentication";
import { keyCloakUtilis as secureUtils} from "../utilis/si-keycloak.utilis";
import { ActivatedRoute, Router } from "@angular/router";
import { keyCloakConfig } from "../models/si-keycloak-config.model";
import { CookieService } from "ngx-cookie";
import { SiKeycloakConfigService } from "src/app/services/si-keycloak-config.service";
import { appResponse } from "../models/si-app-response.model";

@Component({
  selector: "si-keycloak-login",
  templateUrl: "./si-keycloak-login.component.html",
  styleUrls: ["./si-keycloak-login.component.scss"],
})
export class SiKeyCloakLoginComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,private cookieService: CookieService,private siAuthenticationService: SiAuthenticationService, private configService : SiKeycloakConfigService, private router : Router) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
       let hasError : boolean = false;

       if(params['redirects'] && params['status'] === 'prelogin') {

        const state =  secureUtils.generateRandomString(40);
        const codeVerifier = secureUtils.generateRandomString(128);

        //cookie Store for state & codeVerifier, retrive in keycloaktoken api
        this.cookieService.put('keycloakState',state);
        this.cookieService.put('keycloakCodeVerifier',codeVerifier);

        const originUrl : string = (!this.configService.getConfigByKey('cciOriginUrl')) ? window.location.origin : this.configService.getConfigByKey('cciOriginUrl');

        const keyCloakConfigObj = new keyCloakConfig();
        keyCloakConfigObj.setAuthUrl(this.configService.getConfigByKey('oauthLoginUrl'));
        keyCloakConfigObj.setAuthClientId(this.configService.getConfigByKey('oauthClientId'));
        keyCloakConfigObj.setAuthScope(this.configService.getConfigByKey('oauthScope'));
        keyCloakConfigObj.setAuthResponseType(this.configService.getConfigByKey('oauthResponseType'));
        keyCloakConfigObj.setAuthRedirectUrl(originUrl + this.configService.getConfigByKey('oauthPostLoginRedirectApiEndpoint'));
        keyCloakConfigObj.setAuthCodeChallengeMethod(this.configService.getConfigByKey('oauthCodeChallengeMethod'));


        const redirectUrl = secureUtils.getKeyCloakLoginUrl(keyCloakConfigObj,state,codeVerifier);
        if (params['idpType']) {
         const ssoRedirectUrl = redirectUrl + '&kc_idp_hint=' + params['idpType'];
         window.location.href = ssoRedirectUrl;
        } else {
           window.location.href = redirectUrl;
        }

       } else if (params['redirects'] && params['status'] === 'postlogin') {
         let response = this.getAuthResponseFromCookieStore();

         if (response) {
           this.siAuthenticationService.appAuthResponse(response)
             .subscribe((result: boolean) => {
               if (!result) {
                 hasError = true;
                 this.router.navigate(['/unauthorized'], {
                   queryParams: {
                     getClass: "danger",
                     content: "Error Occurred while retriving the App Customers from Response"
                   }
                 });
               }
             });
         } else {
           hasError = true;
           this.router.navigate(['/unauthorized'], {
             queryParams: {
               getClass: "danger",
               content: "Error Occurred while retriving the App Response from Cookie"
             }
           });
         }
       } else if (params['status'] === 'postlogin' && params['error'] && params['code']) {
         hasError = true;
         try {
           let decodedError = atob(params['error']);
           this.router.navigate(['/unauthorized'], {
             queryParams: {
               getClass: "warning",
               content: decodedError
             }
           });
         } catch (error) {
           this.router.navigate(['/unauthorized'], {
             queryParams: {
               getClass: "danger",
               content: "Error Occurred while reading the Error Response"
             }
           });
         }
       }
    });
  }

  getAuthResponseFromCookieStore() : any {
     if(this.cookieService.get('openAMToken') && this.cookieService.get('webToken') && this.cookieService.get('openIDMSession') && this.cookieService.get('userName')) {
       return new appResponse(this.cookieService.get('openAMToken'),this.cookieService.get('webToken'),this.cookieService.get('openIDMSession'),this.cookieService.get('userName'),[]);
     } else {
      this.router.navigate(['/unauthorized'], {
        queryParams: {
          getClass: "danger",
          content: "Error Occurred while retriving the App Auth/Web Token from Response"
        }
      });
     }
  }
}
